import React from "react";
import classes from "./HeadingComponent.module.css";

export default function HeadingComponent({ heading, className }) {
  return <h2 className={[classes.heading, className].join(" ")}>{heading}</h2>;
}
